export default __webpack_public_path__ + "static/media/philo2.59461382.png";